<div
  class="self-start max-w-[85%] px-3.5 py-2.5 rounded-xl rounded-bl b2 leading-normal break-words text-red-700 bg-red-100">
  <span class="whitespace-pre-wrap">{{ content() }}</span>
</div>
